<template>
  <div class="users" style=" margin: auto">

       <users-table @transactionIdChanged="transactionIdChanged"></users-table>

  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import UsersTable from '../components/UsersTable.vue'
export default {
  name: "Users",
  components: {
    UsersTable
  },
  created(){
    this.getPermission('users');
    var vm=this;
    axios({
        method: "get",
        url: "/users/getAllUsersWithDisabled",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization: "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        params: {
          userId:Vue.prototype.$userData.user.id
        }
      })
        .then((response) => {
          vm.users=response.data;
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
  },
  data() {
      
    return {
      users:[],
      transactionIdChanged:0,
      openSortMenu: false,
      ascOrder: false,
    };
  },
  methods: {
    showSortMenu() {
      this.openSortMenu = true;
    },
    getPermission(name){
      const permissions = Vue.prototype.$userData.permissions|| [];
      if ( !permissions.includes(name)) {
        this.$router.push("Landing");
      }
    },
    toggleOrder() {
      this.ascOrder = !this.ascOrder;
    },
  },
};
</script>
<style lang="scss">
.md-list-item-content {
  justify-content: unset;
}
.t-head {
  display: flex;
}
.t-title-group {
  display: flex;
  margin-left: 25px;
}
.t-number {
  width: 24px;
  height: 24px;
  border-radius: 24px;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  background: #e94e1b;
  color: white;
}

.t-body-wrapper {
  padding-left: 50px;
  margin-left: 12.5px;
  border-left: 1px solid lightgray;
  min-height: 20px;
  max-height: 0;

  overflow: hidden;
  padding-top: 1px;
  transition: all 1s ease;
}

.t-body-wrapper.expand {
  max-height: 200px !important;
}

.t-title-info {
  margin-left: 5px;
}

.t-title-type {
  font-weight: bold;
  color: #737373;
  font-size: 16px;
}

.t-title-email {
  color: #969696;
  font-size: 12px;
}

.t-record {
  margin-top: 40px;
  cursor: pointer;
}
.t-body-content i {
  font-size: 1.2em !important;
}
.t-body-content {
  margin-bottom: 15px;
}

.t-record:last-child .t-body-wrapper {
  border: none;
}
.t-record-group {
  // width: 70%;
  // margin:auto;
}
</style>